import { render, staticRenderFns } from "./BoxLink.vue?vue&type=template&id=0d4da82c&"
import script from "./BoxLink.vue?vue&type=script&lang=js&"
export * from "./BoxLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports